import {getQueryFilter} from 'utils/helper'
import {apiAction} from './api'
import {DESK_CLIENT_PORTAL} from './endpoint'
import {
  CREATE_CLIENT_PORTAL_ANNOUNCEMENT,
  DELETE_CLIENT_PORTAL_ANNOUNCEMENT,
  DELETE_CLIENT_PORTAL_LOGO,
  GET_CLIENT_PORTAL_ANNOUNCEMENTS,
  GET_CLIENT_PORTAL_SETTINGS,
  GET_CLIENT_PORTAL_SINGLE_ANNOUNCEMENT,
  GET_CLIENT_PORTAL_TICKET_FORM,
  UPDATE_CLIENT_PORTAL_ANNOUNCEMENT,
  UPDATE_CLIENT_PORTAL_SETTINGS,
  UPDATE_CLIENT_PORTAL_TICKET_FORM,
  UPLOAD_CLIENT_PORTAL_LOGO,
} from './types'

export function createClientPortalAnnouncement(data) {
  return apiAction({
    url: `${DESK_CLIENT_PORTAL}/announcements`,
    method: 'POST',
    label: CREATE_CLIENT_PORTAL_ANNOUNCEMENT,
    data,
    showToast: true,
    successMessage: 'Announcement Created',
  })
}

export function getClientPortalAnnouncements(params) {
  let url = `${DESK_CLIENT_PORTAL}/announcements`
  const qs = getQueryFilter(params)
  if (qs) url += `?${qs}`

  return apiAction({
    url,
    method: 'GET',
    label: GET_CLIENT_PORTAL_ANNOUNCEMENTS,
  })
}

export function getClientPortalSingleAnnouncement(id) {
  return apiAction({
    url: `${DESK_CLIENT_PORTAL}/announcements/${id}`,
    method: 'GET',
    label: GET_CLIENT_PORTAL_SINGLE_ANNOUNCEMENT,
  })
}

export function updateClientPortalAnnouncement(id, data) {
  return apiAction({
    url: `${DESK_CLIENT_PORTAL}/announcements/${id}`,
    method: 'PUT',
    label: UPDATE_CLIENT_PORTAL_ANNOUNCEMENT,
    data,
    showToast: true,
    successMessage: 'Announcement Updated',
  })
}

export function deleteClientPortalAnnouncement(id) {
  return apiAction({
    url: `${DESK_CLIENT_PORTAL}/announcements/${id}`,
    method: 'DELETE',
    label: DELETE_CLIENT_PORTAL_ANNOUNCEMENT,
    showToast: true,
    successMessage: 'Announcement Deleted',
  })
}

export function getClientPortalSettings() {
  return apiAction({
    url: `${DESK_CLIENT_PORTAL}/setting`,
    method: 'GET',
    label: GET_CLIENT_PORTAL_SETTINGS,
  })
}

export function updateClientPortalSettings(data) {
  return apiAction({
    url: `${DESK_CLIENT_PORTAL}/setting`,
    method: 'PUT',
    data,
    label: UPDATE_CLIENT_PORTAL_SETTINGS,
    showToast: true,
    successMessage: 'Settings Updated',
  })
}

export function uploadClientPortalLogo(data) {
  return apiAction({
    url: `${DESK_CLIENT_PORTAL}/logo`,
    method: 'POST',
    label: UPLOAD_CLIENT_PORTAL_LOGO,
    data,
    contentType: 'multipart/form-data',
    showToast: true,
    successMessage: 'Logo Uploaded',
  })
}

export function deleteClientPortalLogo() {
  return apiAction({
    url: `${DESK_CLIENT_PORTAL}/logo`,
    method: 'DELETE',
    label: DELETE_CLIENT_PORTAL_LOGO,
    showToast: true,
    successMessage: 'Logo Deleted',
  })
}

export function getClientPortalTicketForm() {
  return apiAction({
    url: `${DESK_CLIENT_PORTAL}/form`,
    method: 'GET',
    label: GET_CLIENT_PORTAL_TICKET_FORM,
  })
}

export function updateClientPortalTicketForm(data) {
  return apiAction({
    url: `${DESK_CLIENT_PORTAL}/form`,
    method: 'PUT',
    label: UPDATE_CLIENT_PORTAL_TICKET_FORM,
    data,
    showToast: true,
    successMessage: 'Tickets Updated',
  })
}
